import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "routing-addresses-empty" }

import { inject } from 'vue';
import type { Translator } from 'js/shims-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutingAddressesEmptySiren',
  setup(__props) {

const $t = inject('$t') as Translator;

const translations: Record<string, string> = {
    title: $t.__('overview.tabs.TabRoutingAddresses.empty_state.title'),
    caption: $t.__('overview.tabs.TabRoutingAddresses.empty_state.no_siren.subtitle'),
    action: $t.__('overview.tabs.TabRoutingAddresses.empty_state.no_siren.action'),
};

const onCompleteCompany = (): void => {
    // TODO(SAAS-32515): wire up the "Compléter la fiche société" action once backend is available
};

return (_ctx: any,_cache: any) => {
  const _component_CompassButton = _resolveComponent("CompassButton")!
  const _component_CompassEmptyState = _resolveComponent("CompassEmptyState")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CompassEmptyState, {
      illustrationPath: "/ressources/logged/img/illustrations/pdp/empty-contact-create-white.svg",
      title: translations.title,
      caption: translations.caption
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassButton, {
          label: translations.action,
          type: _ctx.CompassEnums.ButtonType.PRIMARY,
          onClick: onCompleteCompany
        }, null, 8 /* PROPS */, ["label", "type"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "caption"])
  ]))
}
}

})